module.exports = __webpack_public_path__ + "img/146.4.06e0f09e.png";